/* EREME: wybór Paczkomatu InPost w koszyku. Stan startowy: window.EREME_PK (snippets/ereme-paczkomat.liquid).
   Od v12 wybór paczkomatu w koszyku jest OPCJONALNY: bez niego klient przechodzi normalnie do kasy,
   a paczkę wysyłamy do paczkomatu najbliższego adresowi podanemu w kasie. */
(function () {
  if (window.__erpk) return;
  window.__erpk = true;

  var API = 'https://api-pl-points.easypack24.net/v1/points';
  var PK = 'Paczkomat InPost';
  var KU = 'Kurier InPost';
  var init = window.EREME_PK || {};
  var st = { mode: init.mode === KU ? KU : PK, code: init.code || '', addr: init.addr || '' };
  var pending = null;
  var uid = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function save() {
    var body = { attributes: { Dostawa: st.mode, Paczkomat: st.mode === PK ? st.code : '', 'Paczkomat adres': st.mode === PK ? st.addr : '' } };
    pending = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }

  function boxHTML() {
    var n = 'erpk_mode_' + uid++;
    return '<div class="erpk" data-erpk><p class="erpk__h">Dostawa</p>' +
      '<label class="erpk__opt"><input type="radio" name="' + n + '" value="' + PK + '"><span>Paczkomat InPost</span><b>0 zł</b></label>' +
      '<div class="erpk__pt" data-erpk-pt></div>' +
      '<label class="erpk__opt"><input type="radio" name="' + n + '" value="' + KU + '"><span>Kurier InPost</span><b>9,99 zł</b></label>' +
      '<p class="erpk__note" data-erpk-note></p></div>';
  }

  function sync(box) {
    box.querySelectorAll('input[type=radio]').forEach(function (r) { r.checked = r.value === st.mode; });
    var pt = box.querySelector('[data-erpk-pt]');
    pt.hidden = st.mode !== PK;
    pt.innerHTML = st.code
      ? '<div class="erpk__sel">Paczkomat: <b>' + esc(st.code) + '</b><br>' + esc(st.addr) + '</div><button type="button" class="erpk__link" data-erpk-open>Zmień paczkomat</button>'
      : '<button type="button" class="erpk__link" data-erpk-open>Wybierz paczkomat na mapie (nie musisz)</button>';
    box.querySelector('[data-erpk-note]').textContent = st.mode === PK
      ? (st.code ? 'Wybrany paczkomat wpiszemy za Ciebie w kasie.' : 'Jeśli nie wybierzesz, wyślemy do paczkomatu najbliżej adresu z kasy.')
      : 'W kasie wybierz metodę dostawy: Kurier InPost.';
  }

  function syncAll() { document.querySelectorAll('[data-erpk]').forEach(sync); }

  function inject() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prev = ctas.previousElementSibling;
      if (prev && prev.hasAttribute('data-erpk')) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = boxHTML();
      var box = wrap.firstChild;
      ctas.parentNode.insertBefore(box, ctas);
      sync(box);
    });
  }

  /* ---------- mapa ---------- */
  var dlg, map, layer, points = [], leaflet, moving = false, moveTimer;

  function loadLeaflet() {
    if (leaflet) return leaflet;
    leaflet = new Promise(function (resolve, reject) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
      js.onload = function () { resolve(window.L); };
      js.onerror = reject;
      document.head.appendChild(js);
    });
    return leaflet;
  }

  function listMsg(t) { dlg.querySelector('[data-erpk-list]').innerHTML = '<li class="erpk-m__msg">' + esc(t) + '</li>'; }

  function addrOf(p) {
    var a = p.address_details || {};
    return ((a.street || '') + ' ' + (a.building_number || '')).trim() + ', ' + (a.post_code || '') + ' ' + (a.city || '');
  }

  function render(items, fit) {
    points = items;
    if (layer) layer.clearLayers();
    if (!items.length) return listMsg('Brak paczkomatów w pobliżu. Spróbuj innego adresu.');
    dlg.querySelector('[data-erpk-list]').innerHTML = items.map(function (p, i) {
      return '<li data-erpk-pick="' + i + '"><b>' + esc(p.name) + '</b>' + esc(addrOf(p)) +
        (p.location_description ? '<br><small>' + esc(p.location_description) + '</small>' : '') + '</li>';
    }).join('');
    if (!layer) return;
    var bounds = [];
    items.forEach(function (p, i) {
      if (!p.location) return;
      var ll = [p.location.latitude, p.location.longitude];
      bounds.push(ll);
      window.L.circleMarker(ll, { radius: 8, color: '#8A6A35', weight: 2, fillColor: '#B08A4E', fillOpacity: 0.9 })
        .bindPopup('<div class="erpk-pop"><b>' + esc(p.name) + '</b>' + esc(addrOf(p)) +
          (p.location_description ? '<br><small>' + esc(p.location_description) + '</small>' : '') +
          '<br><button type="button" class="erpk__btn erpk__btn--primary" data-erpk-pick="' + i + '">Wybieram ten paczkomat</button></div>')
        .addTo(layer);
    });
    if (fit && bounds.length) {
      moving = true;
      map.fitBounds(bounds.slice(0, 12), { padding: [30, 30], maxZoom: 15 });
      setTimeout(function () { moving = false; }, 600);
    }
  }

  function fetchPoints(query, fit) {
    listMsg('Szukam paczkomatów…');
    var url = API + '?type=parcel_locker_only&per_page=40&fields=name,address_details,location,location_description,status&' + query;
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d.items || []).filter(function (p) { return !p.status || p.status === 'Operating'; });
        return loadLeaflet().catch(function () {}).then(function () { render(items, fit); });
      })
      .catch(function () { listMsg('Nie udało się pobrać paczkomatów. Spróbuj ponownie.'); });
  }

  function search(q) {
    q = (q || '').trim();
    if (!q) return;
    var pc = q.match(/^(\d{2})-?(\d{3})$/);
    if (pc) return fetchPoints('relative_post_code=' + pc[1] + '-' + pc[2], true);
    var code = q.toUpperCase().replace(/\s+/g, '');
    if (/^[A-Z]{3}\d{1,4}[A-Z]{0,3}$/.test(code)) return fetchPoints('name=' + encodeURIComponent(code), true);
    listMsg('Szukam adresu…');
    fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=pl&accept-language=pl&q=' + encodeURIComponent(q))
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || !res.length) return listMsg('Nie znaleziono adresu. Wpisz kod pocztowy, np. 00-001.');
        fetchPoints('relative_point=' + res[0].lat + ',' + res[0].lon, true);
      })
      .catch(function () { listMsg('Nie znaleziono adresu. Wpisz kod pocztowy, np. 00-001.'); });
  }

  function buildDialog() {
    dlg = document.createElement('dialog');
    dlg.className = 'erpk-m';
    dlg.setAttribute('aria-label', 'Wybierz Paczkomat');
    dlg.innerHTML = '<div class="erpk-m__in">' +
      '<div class="erpk-m__hd"><h2>Wybierz Paczkomat</h2><button type="button" class="erpk-m__x" aria-label="Zamknij" data-erpk-close>×</button></div>' +
      '<form class="erpk-m__f" data-erpk-search><input name="q" placeholder="Kod pocztowy, miasto i ulica lub kod paczkomatu" aria-label="Szukaj paczkomatu">' +
      '<button class="erpk__btn erpk__btn--primary" type="submit">Szukaj</button><button class="erpk__btn" type="button" data-erpk-geo>Blisko mnie</button></form>' +
      '<div class="erpk-m__body"><div class="erpk-m__map" data-erpk-map></div><ul class="erpk-m__list" data-erpk-list></ul></div></div>';
    document.body.appendChild(dlg);

    dlg.querySelector('[data-erpk-search]').addEventListener('submit', function (e) {
      e.preventDefault();
      search(this.q.value);
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-erpk-close]')) return dlg.close();
      if (e.target.closest('[data-erpk-geo]')) {
        if (!navigator.geolocation) return listMsg('Twoja przeglądarka nie udostępnia lokalizacji.');
        listMsg('Ustalam Twoją lokalizację…');
        navigator.geolocation.getCurrentPosition(
          function (pos) { fetchPoints('relative_point=' + pos.coords.latitude + ',' + pos.coords.longitude, true); },
          function () { listMsg('Brak dostępu do lokalizacji. Wpisz kod pocztowy.'); },
          { timeout: 10000 }
        );
        return;
      }
      var pick = e.target.closest('[data-erpk-pick]');
      if (pick) {
        var p = points[+pick.getAttribute('data-erpk-pick')];
        if (!p) return;
        st.mode = PK;
        st.code = p.name;
        st.addr = addrOf(p);
        save();
        syncAll();
        dlg.close();
      }
    });
    listMsg('Wpisz kod pocztowy lub miasto i ulicę, albo kliknij „Blisko mnie”.');
  }

  function openM() {
    if (!dlg) buildDialog();
    dlg.showModal();
    loadLeaflet().then(function (L) {
      if (!map) {
        map = L.map(dlg.querySelector('[data-erpk-map]')).setView([52.07, 19.48], 6);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap' }).addTo(map);
        layer = L.layerGroup().addTo(map);
        map.on('moveend', function () {
          if (moving || map.getZoom() < 13) return;
          clearTimeout(moveTimer);
          moveTimer = setTimeout(function () {
            var c = map.getCenter();
            fetchPoints('relative_point=' + c.lat.toFixed(5) + ',' + c.lng.toFixed(5), false);
          }, 400);
        });
      }
      setTimeout(function () { map.invalidateSize(); }, 60);
    }).catch(function () { listMsg('Mapa się nie wczytała, ale możesz wyszukać paczkomat po kodzie pocztowym.'); });
    setTimeout(function () { var i = dlg.querySelector('input[name=q]'); if (i) i.focus(); }, 50);
  }

  /* ---------- kasa: adres paczkomatu wpisany z góry, a przy zmianie na kuriera wyczyszczony ---------- */
  var PRE = 'erpk_prefilled';

  function prefilled(set) {
    try {
      if (set === true) sessionStorage.setItem(PRE, '1');
      else if (set === false) sessionStorage.removeItem(PRE);
      return sessionStorage.getItem(PRE) === '1';
    } catch (_) { return false; }
  }

  function checkoutUrl(fields) {
    return '/checkout?' + fields.map(function (f) {
      return 'checkout[shipping_address][' + f[0] + ']=' + encodeURIComponent(f[1]);
    }).join('&');
  }

  function pkUrl() {
    var m = st.addr.match(/^(.*), (\d{2}-\d{3}) (.*)$/);
    if (!m) return '/checkout';
    return checkoutUrl([['address1', 'Paczkomat ' + st.code + ', ' + m[1]], ['zip', m[2]], ['city', m[3]], ['country', 'PL']]);
  }

  function goTo(url) {
    (pending || Promise.resolve()).then(function () { location.href = url; });
  }

  /* ---------- zdarzenia ---------- */
  // Nigdy nie blokujemy przejścia do kasy. Gdy paczkomat jest wybrany — wpisujemy jego adres w kasie.
  function handleCheckout(e, btn) {
    if (st.mode === PK && st.code) {
      e.preventDefault();
      e.stopImmediatePropagation();
      prefilled(true);
      goTo(pkUrl());
      return;
    }
    if (prefilled()) {
      // Wcześniej wpisaliśmy adres paczkomatu, a klient go zmienił/usunął — czyścimy pola adresu.
      e.preventDefault();
      e.stopImmediatePropagation();
      prefilled(false);
      goTo(checkoutUrl([['address1', ''], ['zip', ''], ['city', '']]));
      return;
    }
    if (pending) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var form = document.getElementById('cart-form');
      pending.then(function () { if (form) form.requestSubmit(btn); else location.href = '/checkout'; });
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-erpk] input[type=radio]')) {
      st.mode = e.target.value;
      save();
      syncAll();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-erpk-open]')) {
      e.preventDefault();
      openM();
      return;
    }
    var btn = e.target.closest('button[name="checkout"]');
    if (btn) handleCheckout(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'cart-form' && e.submitter && e.submitter.name === 'checkout') handleCheckout(e, e.submitter);
  }, true);

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; inject(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
})();
